import Vue from 'vue';
import Vuex from 'vuex';

import Modules from './store-modules';

import UserModule from './modules/user';
import ProductsModule from './modules/products';
import ProductAttributesModule from './modules/product-attributes';
import ProductGroupsModule from './modules/product-groups';
import SystemsModule from './modules/systems';
import SystemAttributesModule from './modules/system-attributes';
import SystemGroupsModule from './modules/system-groups';
import NewsModule from './modules/news';
import ProductDetailModule from './modules/product-detail';
import SystemDetailModule from './modules/system-detail';
import CartModule from './modules/cart';
import SystemApplicationsModule from './modules/system-applications';
import DeliveryAddressModule from './modules/delivery-address';
import CheckoutModule from './modules/checkout';
Vue.use(Vuex);

const modules = {
  [Modules.USER]: UserModule,
  [Modules.PRODUCTS]: ProductsModule,
  [Modules.PRODUCT_ATTRIBUTES]: ProductAttributesModule,
  [Modules.PRODUCT_GROUPS]: ProductGroupsModule,
  [Modules.SYSTEMS]: SystemsModule,
  [Modules.SYSTEM_ATTRIBUTES]: SystemAttributesModule,
  [Modules.SYSTEM_GROUPS]: SystemGroupsModule,
  [Modules.SYSTEMS]: SystemsModule,
  [Modules.NEWS]: NewsModule,
  [Modules.PRODUCT_DETAIL]: ProductDetailModule,
  [Modules.SYSTEM_DETAIL]: SystemDetailModule,
  [Modules.CART]: CartModule,
  [Modules.SYSTEM_APPLICATIONS]: SystemApplicationsModule,
  [Modules.DELIVERY_ADDRESSES]: DeliveryAddressModule,
  [Modules.CHECKOUT]: CheckoutModule,
};

export default new Vuex.Store({
  modules,
});
